
import MoveTable from '@/components/MoveTable/MoveTable.vue';
import { defineComponent, onMounted, Ref, ref, toRefs, watch} from 'vue'
import request from '@/utils/request'
export default defineComponent({
  name: "TopTwoTop50",
  components: {
    MoveTable,
  },
  setup() {
    const tableTitle: Ref<any> = ref({
      port: '港口',
      tdh: '提单号',
      hc: '航次',
      xh: '箱号',
    });
    let tableData: Ref<Array<any>> = ref([]);
    onMounted(() => {
      const fetchData = () => {
        request({
          url: 'https://apiplat.sdland-sea.com/getNewList/getNewsZxdList?key=00f5d8ffd3a2481982cf32c8aa0a5355',
          method: 'get',
        }).then((res: any) => {
          tableData.value = res.datas
        })
      }
      fetchData();
      setInterval(() => {
        fetchData();
      }, 3600000);
    })
    return {
      tableTitle,
      tableData,
    }
  },
})
